var NotFoundPage = /** @class */ (function () {
    function NotFoundPage() {
        this.animationSpeed = 1;
        this.lottieConfig = {
            path: 'assets/images/404_page.json',
            renderer: 'canvas',
            autoplay: true,
            loop: true
        };
    }
    NotFoundPage.prototype.handleAnimation = function (anim) {
        this.anim = anim;
    };
    return NotFoundPage;
}());
export { NotFoundPage };
